import * as React from "react";
import { useMemo } from "react";

import { CodeNodeLabel } from "../TreeNode.styles";
import { DEFAULT_ELEMENT_ID_COLUMN_NAME, TreePicklistItem } from "../../TreePicklistItem";

export const useNodeLabelName = (display: string[], item: TreePicklistItem) => {
    const labelName = useMemo(() => createLabelName(display, item), [display, item]);

    return labelName;
};

const createLabelName = (display: string[], item: TreePicklistItem) =>
    display.map(displayName => {
        const displayText = (item.toOriginal()[displayName] ?? "") as string;
        const nodeText = <CodeNodeLabel isCode={displayName === "code"}>{displayText}</CodeNodeLabel>;

        return nodeText;
    });

export const useMultipleNodeLabelName = (display: string[], item: TreePicklistItem) => {
    const filteredDisplayNames = useFilteredDisplayNames(display, item);
    const labelName = useNodeLabelName(filteredDisplayNames, item);

    return labelName;
};

const useFilteredDisplayNames = (display: string[], item: TreePicklistItem) =>
    useMemo(() => {
        if (item.isAvailableForSaving) {
            return display;
        }

        return display.filter(it => it !== DEFAULT_ELEMENT_ID_COLUMN_NAME);
    }, [display, item]);
